import { render } from "./text-styler-parent-popover.vue?vue&type=template&id=7eef5578"
import script from "./text-styler-parent-popover.vue?vue&type=script&lang=js"
export * from "./text-styler-parent-popover.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__